import script from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./Checkbox.vue?vue&type=style&index=0&id=06273d90&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06273d90"]])

export default __exports__